import { MeshBasicMaterial } from "three";

/**
 * A material used on invisible hit geometry.
 */
export const hitPlaneMaterial = new MeshBasicMaterial({
    color: 0x00FF00
});

export default hitPlaneMaterial;
